import React, { Component } from "react";
import { translate } from "react-i18next";
import InputForm from "../../components/InputForm";
import LabelForm from "../../components/LabelForm";
import SelectForm from "../../components/SelectForm";
import { biometricsDataByOfferCells, biometricsOption } from "../../libs/services";

class BiometricsData extends Component{
    constructor(props){
        super(props);

        this.getBiometrics = this.getBiometrics.bind(this);
        this.getBiometrictsData = this.getBiometrictsData.bind(this);
        this.changeCombo = this.changeCombo.bind(this);
        this.calculateValuesBIO = this.calculateValuesBIO.bind(this);
        this.validateRangeBiometric = this.validateRangeBiometric.bind(this);
        this.getTerms = this.getTerms.bind(this);

        this.state = {
            biometrics:[],
        }
    }

    componentDidMount(){
        this.props.onRef(this);
    }

    componentWillUnmount(){
        this.props.onRef(null);
    }

    async getBiometrics(sex){
        var id = this.props.match.params.id === undefined ? this.props.variables.id : this.props.match.params.id;
        var type = this.props.match.params.type === undefined ? this.props.variables.type : this.props.match.params.type;        

        var response = await biometricsOption('BIO_F_BIO', sex);
        if(response){
            response.forEach((res)=>{
                res.value = '';
                res.borderColor = '#ccc';
                res.class = '';

                if(type === 'CELLS'){
                    res.offering_cell_id = id;

                    res.biometrics_options.forEach((option)=>{
                        option.value = option.value;
                        option.text = option.value;
                    });
                }
            });
            
			await this.setState({biometrics: response});
            await this.getBiometrictsData();
        }
    }

    async getBiometrictsData(){
        var id = this.props.match.params.id === undefined ? this.props.variables.id : this.props.match.params.id;
        var type = 'BIO_F_BIO';

		var response = await biometricsDataByOfferCells(id, type);

		if(response !== undefined){
            var biometrics = this.state.biometrics;
            biometrics.forEach((item, i)=>{
                var index = response.values.findIndex(obj => obj.biometrics_id === item.id);
                if(index !== -1){
                    var obj = {
                        target:{
                            id:item.id,
                            value:response.values[index].value
                        }
                    };

                    if(item.data_type === 'BIO_D_SELECT' || item.data_type === 'BIO_D_OPEN'){
                        this.changeCombo(obj);
                    }else{
                        this.calculateValuesBIO(obj);
                    }
                    
                }
            });

            if(this.props.handleChange !== undefined){
                this.props.handleChange({target:{
                    name:'invalid_sample', 
                    value:response.sample_valid === null ? '' : response.sample_valid ? 'SI' : 'NO'
                }});
                this.props.handleChange({target:{name:'incident_id', value:response.incident_id}});
            }
            
		}
	}

    changeCombo(e, i){
		var biometrics = this.state.biometrics;

		biometrics[i].value = e.target.value;

		this.setState({biometrics: biometrics});
	}

    async calculateValuesBIO(e){
		var id = parseInt(e.target.id);
        var value = e.target.value;

		await this.validateRangeBiometric(id, value);

        var biometrics = this.state.biometrics;

        biometrics.forEach((biometric)=>{
            if(biometric.data_type === 'BIO_D_CALCULATED'){
                var str = biometric.formula.split('&');
                var val = this.getTerms(str, value);

                if(val !== ''){
                    if(biometric.required && biometric.class === 'error'){
                        biometric.class = '';
                    }
                    biometric.value = val;
                    biometric.class = '';
                }else{
                    biometric.value = '';
                    biometric.class = 'error';
                }
            }
        });
        
        var index = biometrics.findIndex(item => item.id === id);
        if(index !== -1){
            biometrics[index].value = value;
        }
    

        this.setState({biometrics:biometrics});
	}

    validateRangeBiometric(id, value){
        var biometrics = this.state.biometrics;

        var index = biometrics.findIndex(item => item.id === id);

        if(index !== -1){
            if(biometrics[index].ranges_validation){
                var val = parseFloat(value);

                if(this.props.sex ==='HOMBRE'){
                    if(val >= biometrics[index].low_rank_male && val <= biometrics[index].high_rank_male){
                        biometrics[index].borderColor = '#ccc';
                    }else{
                        biometrics[index].borderColor = 'red';
                    }
                }else{
                    if(val >= biometrics[index].low_rank_female && val <= biometrics[index].high_rank_female){
                        biometrics[index].borderColor = '#ccc';
                    }else{
                        biometrics[index].borderColor = 'red';
                    }
                }
            }
        }

        this.setState({biometrics:biometrics});
	}

    getTerms(term, value){
		var result = "";
		var formula = "";

        term.forEach((t)=>{
            var id = parseFloat(t);
            if(!isNaN(id)){
                var index  = this.state.biometrics.findIndex(item => item.id === id);                
                if(index !== -1){
                    formula = formula + this.state.biometrics[index].value
                }
            }else{
                formula = formula + t;
            }
        });		

		try{
			result =  eval(formula);
		}catch(e){
			return "";
		}

		if (!isNaN(result)) {
			return (result).toFixed(2);
		} else{
			return "";
		};
	}

    render(){
        return(
            <fieldset>
                {!this.props.vertical && <legend>Biometría Hemática</legend>}
                <div className={this.props.container}>
                    {this.state.biometrics.map((biometric, i)=>
                        biometric.show_in_ch &&
                        <div key={i}>
                            <div className={this.props.vertical ? "col-xs-12" : "col-xs-12 "}>
                                <LabelForm text={biometric.name} />
                                {biometric.data_type === 'BIO_D_SELECT' ?
                                    <SelectForm 
                                        id={biometric.id}
                                        required={biometric.required}
                                        value={biometric.value}
                                        handleChange={this.changeCombo}
                                        variables={i}
                                        options={biometric.biometrics_options}
                                        styles={{borderColor: biometric.borderColor}}
                                        disabled={(!this.props.task_biometrics.create && !this.props.task_biometrics.update) || this.props.exist_extraction}
                                    />    
                                
                                : biometric.data_type === 'BIO_D_OPEN' ?
                                    <InputForm 
                                        id={biometric.id}
                                        value={biometric.value}
                                        maxLength={50}
                                        handleChange={this.changeCombo}
                                        variables={i}
                                        required={biometric.required}
                                        styles={{borderColor: biometric.borderColor}}
                                        disabled={(!this.props.task_biometrics.create && !this.props.task_biometrics.update) || this.props.exist_extraction}
                                    />
                                :
                                    <InputForm 
                                        id={biometric.id}
                                        value={biometric.value}
                                        type="number"
                                        maxLength={4}
                                        handleChange={this.calculateValuesBIO}
                                        required={biometric.required}
                                        styles={{borderColor: biometric.borderColor}}
                                        disabled={(!this.props.task_biometrics.create && !this.props.task_biometrics.update) || this.props.exist_extraction}
                                    />
                            }
                            </div>
                            {this.props.vertical &&
                                <div className="col-xs-4 col-sm-3">
                                    <LabelForm text={biometric.units} />
                                </div>
                            }
                        </div>
                    )} 
                </div>
            </fieldset>
        )
    }
}

export default translate('translations') (BiometricsData);

BiometricsData.defaultProps = {
    container: 'biometrics-container',
    vertical: false
};